import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import HomePage from '@/pages/HomePage';
import LegalAIPage from '@/pages/LegalAIPage';

function App() {
  return (
    <BrowserRouter>
      <div className="app" data-testid="app-root">
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/legal-ai" element={<LegalAIPage />} />
          <Route path="/matter" element={<Navigate to="/legal-ai" replace />} />
          <Route path="/soundboard-matter" element={<Navigate to="/legal-ai" replace />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
